import React from 'react';
import { Badge } from '../ui/badge';

type FlowPathBadgeProps = {
    label?: string | null;
};

export const FlowPathBadge: React.FC<FlowPathBadgeProps> = ({ label }) => {
    if (!label) return null;
    return (
        <Badge variant="outline" className="border-blue-200 bg-blue-50 text-blue-700">
            Path: {label}
        </Badge>
    );
};

